export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/CalculateFooter.worker.5436733e.worker.js");
}
